/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { createContext, useContext } from "react";

import { BasePlayerCallbacks } from "../types";

const defaultCallbacks: BasePlayerCallbacks = {};

const PlayerCallbacksContext =
  createContext<BasePlayerCallbacks>(defaultCallbacks);

export const PlayerCallbacksProvider: React.FC<{
  callbacks: BasePlayerCallbacks;
  children: React.ReactNode;
}> = ({ callbacks, children }) => {
  return (
    <PlayerCallbacksContext.Provider value={callbacks}>
      {children}
    </PlayerCallbacksContext.Provider>
  );
};

export const usePlayerCallbacks = (): BasePlayerCallbacks => {
  return useContext(PlayerCallbacksContext);
};
